const fromStoreByIdQueryToStore = (data) => {
  if (!data) {
    return null;
  }
  const {
    town,
    streetName,
    name,
    postalCode,
    additionalStreetInfo,
    streetNumber,
    code,
    globalStoreId
  } = data;
  return {
    globalStoreId,
    town,
    streetName,
    name,
    code,
    postalCode: postalCode ? postalCode : void 0,
    additionalStreetInfo: additionalStreetInfo ? additionalStreetInfo : void 0,
    streetNumber: streetNumber ? streetNumber : void 0
  };
};
export {
  fromStoreByIdQueryToStore
};
//# sourceMappingURL=fromStoreByIdQueryToStore.js.map
